import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBed: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBed"><Path d="M4 4H11V9H4V4Z" fill="currentColor"/><Path d="M13 9V4H20V9H13Z" fill="currentColor"/><Path d="M22 11H2V18H4V20H6V18H18V20H20V18H22V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBed;
